module.exports = __webpack_public_path__ + "img/consultation@2x.9287483.webp";